import React from 'react';
import {
  Button, Row, Col, Form, Collapse, Tab, Tabs,
} from 'react-bootstrap';
import { BsPlusCircleFill } from 'react-icons/bs';
import {
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle,
} from 'react-icons/io';
import '../style/style.css';
import PropTypes from 'prop-types';
import notFoundImage from '../not-found-image.png';
import { getContent } from '../api';
import {
  addService,
  deleteService,
  updateService,
  updateServiceFile,
  swapKeys,
} from '../services/Services';
import DeleteModal from './Modal';
import SuccessMessage from './SuccessMessage';

/* eslint no-underscore-dangle: 0 */

function orderList(List) {
  return List.sort((a, b) => Number(a.key) - Number(b.key));
}

let succeed = true;
class ServicesEdit extends React.Component {
  constructor(props) {
    super(props);
    const { Services } = this.props;
    this.state = {
      open: false,
      titleEs: null,
      titlePt: null,
      descriptionPt: null,
      descriptionEs: null,
      image: null,
      servicesList: orderList(Services),
      showModal: false,
      idModal: '',
      titleModal: '',
      error: null,
      showToast: false,
      message: '',
    };
  }

  setShow = (value) => {
    this.setState({ showToast: value });
  };

  setMessage = (value) => {
    this.setShow(false);
    this.setShow(true);
    this.setState({ message: value });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  handleShow = (id, title) => {
    this.setState({ showModal: true });
    this.setState({ idModal: id });
    this.setState({ titleModal: title });
  };

  handleDelete = () => {
    const { idModal } = this.state;
    deleteService(idModal)
      .catch((err) => {
        succeed = false;
        document.getElementById(idModal).textContent = err.response.data.message;
      })
      .then(() => {
        if (succeed) {
          document.getElementById(idModal).textContent = null;
          this.updateServices();
          this.setMessage('Serviço eliminado com sucesso!');
        }
      });
    this.setState({ showModal: false });
  };

  setOpen() {
    const { open } = this.state;
    if (!open) document.getElementById('new-service').reset();
    this.setState({ open: !open });
  }

  setTitleEs(value) {
    this.setState({ titleEs: value });
  }

  setTitlePt(value) {
    this.setState({ titlePt: value });
  }

  setDescriptionPt(value) {
    this.setState({ descriptionPt: value });
  }

  setDescriptionEs(value) {
    this.setState({ descriptionEs: value });
  }

  setImage(value) {
    this.setState({ image: value });
  }

  setServicesList(value) {
    this.setState({ servicesList: orderList(value) });
  }

  setError(value) {
    this.setState({ error: value });
  }

  editServices = async (e, key) => {
    e.preventDefault();

    succeed = true;
    const form = e.target.closest('form');
    if (form === null) return;

    const id = form.dataset.reactid;
    const formTitlePt = document.querySelector(
      `[data-reactid='${id}'] .edit-service-title-pt`,
    );
    const formTitleEs = document.querySelector(
      `[data-reactid='${id}'] .edit-service-title-es`,
    );
    const formDescriptionPt = document.querySelector(
      `[data-reactid='${id}'] .edit-service-description-pt`,
    );
    const formDescriptionEs = document.querySelector(
      `[data-reactid='${id}'] .edit-service-description-es`,
    );
    const formImage = document.querySelector(
      `[data-reactid='${id}'] .edit-service-image`,
    ).files[0];

    if (
      formTitleEs.value !== formTitleEs.defaultValue
      || formDescriptionPt.value !== formDescriptionPt.defaultValue
      || formTitlePt.value !== formTitlePt.defaultValue
      || formDescriptionEs.value !== formDescriptionEs.defaultValue
      || formImage !== undefined
    ) {
      if (formImage === undefined) {
        updateService(
          id,
          formTitlePt.value,
          formTitleEs.value,
          formDescriptionPt.value,
          formDescriptionEs.value,
          'blob',
          key,
        )
          .catch((err) => {
            succeed = false;
            document.getElementById(id).textContent = err.response.data.message;
          })
          .then(() => {
            if (succeed) {
              formTitlePt.defaultValue = formTitlePt.value;
              formDescriptionPt.defaultValue = formDescriptionPt.value;
              formTitleEs.defaultValue = formTitleEs.value;
              formDescriptionEs.defaultValue = formDescriptionEs.value;
              document.getElementById(id).textContent = null;
              this.setMessage('Serviço editado com sucesso!');
            }
          });
      } else {
        updateServiceFile(
          id,
          formTitlePt.value,
          formTitleEs.value,
          formDescriptionPt.value,
          formDescriptionEs.value,
          formImage,
          key,
        )
          .catch((err) => {
            succeed = false;
            document.getElementById(id).textContent = err.response.data.message;
          })
          .then(() => {
            if (succeed) {
              formTitlePt.defaultValue = formTitlePt.value;
              formDescriptionPt.defaultValue = formDescriptionPt.value;
              formTitleEs.defaultValue = formTitleEs.value;
              formDescriptionEs.defaultValue = formDescriptionEs.value;
              document.getElementById(id).textContent = null;
              this.setMessage('Serviço editado com sucesso!');
            }
          });
      }
    }
  };

  insertServices = async (e) => {
    e.preventDefault();

    succeed = true;

    const {
      titlePt, titleEs, descriptionPt, descriptionEs, image,
    } = this.state;
    if (image === null) {
      this.setError('Insira uma imagem!');
      return;
    }
    addService(
      titlePt,
      titleEs,
      this.findBiggerKey() + 1,
      descriptionPt,
      descriptionEs,
      image,
    )
      .catch((err) => {
        this.setState({ open: true });
        succeed = false;
        this.setError(err.response.data.message);
      })
      .then(() => {
        if (succeed) {
          this.setState({ open: false });
          e.target.closest('form').reset();
          this.setError(null);
          this.updateServices();
          this.setMessage('Serviço adicionado com sucesso!');
        }
      });
  };

  resetServices = async (e) => {
    e.preventDefault();
    const form = e.target.closest('form');
    if (form === null) return;
    form.reset();
  };

  updateServices() {
    getContent().then((res) => {
      this.setState({ servicesList: orderList(res.data.services) });
    });
  }

  findSmallerKeyThan(key) {
    let small = -1;
    const { servicesList } = this.state;
    for (let i = 0; i < servicesList.length; i += 1) {
      const k = Number(servicesList[i].key);
      if (k < key && k > small) small = k;
    }
    return small;
  }

  findBiggerKeyThan(key) {
    let big = -1;
    const { servicesList } = this.state;
    for (let i = 0; i < servicesList.length; i += 1) {
      const k = Number(servicesList[i].key);
      if (big === -1 && k > key) big = k;
      else if (k > key && k < big) big = k;
    }
    return big;
  }

  findSmallerKey() {
    const { servicesList } = this.state;
    return Math.min(...servicesList.map((obj) => Number(obj.key)));
  }

  findBiggerKey() {
    const { servicesList } = this.state;
    return Math.max(...servicesList.map((obj) => Number(obj.key)));
  }

  upService(id) {
    const { servicesList } = this.state;
    const item1 = servicesList.find((element) => element._id === id);
    const key1 = Number(item1.key);
    if (servicesList.length <= 1 || key1 === this.findSmallerKey()) return;
    const key2 = this.findSmallerKeyThan(key1);
    const item2 = servicesList.find(
      (element) => element.key === key2.toString(),
    );
    item1.key = key2.toString();
    item2.key = key1.toString();
    swapKeys(id, item2._id, key1.toString(), key2.toString());
    this.setServicesList(servicesList);
    this.setMessage(
      `Posição do serviço '${item1.title1.pt}' modificada com sucesso!`,
    );
  }

  downService(id) {
    const { servicesList } = this.state;
    const item1 = servicesList.find((element) => element._id === id);
    const key1 = Number(item1.key);
    if (servicesList.length <= 1 || key1 === this.findBiggerKey()) return;
    const key2 = this.findBiggerKeyThan(key1);
    const item2 = servicesList.find(
      (element) => element.key === key2.toString(),
    );
    item1.key = key2.toString();
    item2.key = key1.toString();
    swapKeys(id, item2._id, key1.toString(), key2.toString());
    this.setServicesList(servicesList);
    this.setMessage(
      `Posição do serviço '${item1.title1.pt}' modificada com sucesso!`,
    );
  }

  render() {
    const {
      open,
      servicesList,
      idModal,
      showModal,
      titleModal,
      error,
      showToast,
      message,
    } = this.state;
    return (
      <div className="section-edit" id="editar-serviços">
        <Row className="d-flex align-items-center justify-content-between">
          <Col className="col-10 d-flex flex-column">
            <h2 className="title my-auto">Editar Serviços</h2>
          </Col>
          <Col className="col-2 d-flex flex-column ps-0">
            <BsPlusCircleFill
              onClick={() => this.setOpen()}
              aria-controls="collapse-new-service"
              aria-expanded={open}
              className="edit-icon ms-auto"
              color="#C4C4C4"
              size="70px"
              id="plus-circle-services"
              title="Adicionar Serviço"
            />
          </Col>
        </Row>
        <hr className="edit-divider" />
        <div className="edit-card">
          <Collapse in={open}>
            <div id="collapse-new-service">
              <Form id="new-service">
                <Tabs defaultActiveKey="PT" id="new-service" className="mb-3">
                  <Tab eventKey="PT" title="PT">
                    <Form.Control
                      as="textarea"
                      id="new-service-title-pt"
                      rows={1}
                      style={{ resize: 'none' }}
                      placeholder="Adicione Título do Serviço em Português"
                      onChange={(e) => {
                        this.setTitlePt(e.target.value);
                      }}
                    />
                    <Row className="d-flex align-items-center justify-content-between">
                      <Col lg={9} md={8} sm={12}>
                        <Form.Control
                          as="textarea"
                          id="new-service-description-pt"
                          className="mt-2"
                          rows={7}
                          style={{ resize: 'none' }}
                          placeholder="Adicione Descrição do Serviço em Português"
                          onChange={(e) => {
                            this.setDescriptionPt(e.target.value);
                          }}
                        />
                      </Col>
                      <Col>
                        <div
                          className="edit-card-pad"
                          style={{ marginTop: '1em' }}
                        >
                          <img
                            className="upload-new-image"
                            src={notFoundImage}
                            alt="imagem do serviço"
                            width="200px"
                            height="172px"
                          />
                          <div className="upload-image-div">
                            <label className="upload-image-text custom-file-upload">
                              <input
                                type="file"
                                onChange={(e) => {
                                  this.setImage(e.target.files[0]);
                                  document.getElementsByClassName('upload-new-image')[0].src = URL
                                    .createObjectURL(e.target.files[0]);
                                  document.getElementsByClassName('upload-new-image')[1].src = URL
                                    .createObjectURL(e.target.files[0]);
                                }}
                              />
                              Adicionar Imagem
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="ES" title="ES">
                    <Form.Control
                      as="textarea"
                      id="new-service-title-es"
                      rows={1}
                      style={{ resize: 'none' }}
                      placeholder="Adicione Título do Serviço em Espanhol"
                      onChange={(e) => {
                        this.setTitleEs(e.target.value);
                      }}
                    />
                    <Row className="d-flex align-items-center justify-content-between">
                      <Col lg={9} md={8} sm={12}>
                        <Form.Control
                          as="textarea"
                          id="new-service-description-es"
                          className="mt-2"
                          rows={7}
                          style={{ resize: 'none' }}
                          placeholder="Adicione Descrição do Serviço em Espanhol"
                          onChange={(e) => {
                            this.setDescriptionEs(e.target.value);
                          }}
                        />
                      </Col>
                      <Col>
                        <div
                          className="edit-card-pad"
                          style={{ marginTop: '1em' }}
                        >
                          <img
                            className="upload-new-image"
                            src={notFoundImage}
                            alt="imagem do serviço"
                            width="205px"
                            height="172px"
                          />
                          <div className="upload-image-div">
                            <label className="upload-image-text custom-file-upload">
                              <input
                                type="file"
                                onChange={(e) => {
                                  this.setImage(e.target.files[0]);
                                  document.getElementsByClassName('upload-new-image')[0].src = URL
                                    .createObjectURL(e.target.files[0]);
                                  document.getElementsByClassName('upload-new-image')[1].src = URL
                                    .createObjectURL(e.target.files[0]);
                                }}
                              />
                              Alterar Imagem
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
                <div>
                  <small id="1" className="text-danger pre-wrap">
                    {error}
                  </small>
                </div>
                <div className="d-flex justify-content-md-start justify-content-center">
                  <Button
                    onClick={(e) => this.insertServices(e)}
                    variant="principal btn-custom"
                  >
                    Guardar alterações
                  </Button>
                  <Button
                    onClick={(e) => this.resetServices(e)}
                    variant="cancel btn-custom"
                  >
                    Cancelar
                  </Button>
                </div>
              </Form>

              <hr className="edit-divider" />
            </div>
          </Collapse>
          <div id="services">
            {servicesList.map((services) => (
              <Form data-reactid={services._id} key={services._id}>
                <Tabs defaultActiveKey="PT" id="new-service" className="mb-3">
                  <Tab eventKey="PT" title="PT">
                    <Row className="align-items-center services-first-row">
                      <Col sm={8} md={10}>
                        <Form.Control
                          as="textarea"
                          className="edit-service-title-pt"
                          rows={1}
                          style={{ resize: 'none' }}
                          defaultValue={services.title1.pt}
                          placeholder="Adicione Título do Serviço em Português"
                        />
                      </Col>
                      <Col>
                        <IoIosArrowDropdownCircle
                          className="services-icon"
                          onClick={() => this.downService(services._id)}
                          size={60}
                          title="Descer serviço"
                        />
                        <IoIosArrowDropupCircle
                          className="services-icon"
                          onClick={() => this.upService(services._id)}
                          size={60}
                          title="Subir serviço"
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex align-items-center justify-content-between">
                      <Col lg={9} md={8} sm={12}>
                        <Form.Control
                          as="textarea"
                          className="edit-service-description-pt mt-2"
                          rows={7}
                          style={{ resize: 'none' }}
                          defaultValue={services.description1.pt}
                          placeholder="Adicione Descrição do Serviço em Português"
                        />
                      </Col>
                      <Col>
                        <div
                          className="edit-card-pad"
                          style={{ marginTop: '1em' }}
                        >
                          <img
                            className={services._id}
                            src={`${process.env.REACT_APP_API_URI}/api/image/${services.image}`}
                            alt="imagem do serviço"
                            width="205px"
                            height="172px"
                          />
                          <div className="upload-image-div">
                            <label className="upload-image-text custom-file-upload">
                              <input
                                className="edit-service-image"
                                type="file"
                                onChange={(e) => {
                                  document.getElementsByClassName(services._id)[0].src = URL
                                    .createObjectURL(e.target.files[0]);
                                  document.getElementsByClassName(services._id)[1].src = URL
                                    .createObjectURL(e.target.files[0]);
                                }}
                              />
                              Alterar Imagem
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="ES" title="ES">
                    <Row className="align-items-center">
                      <Col md={10}>
                        <Form.Control
                          as="textarea"
                          className="edit-service-title-es"
                          rows={1}
                          style={{ resize: 'none' }}
                          defaultValue={services.title1.es}
                          placeholder="Adicione Título do Serviço em Espanhol"
                        />
                      </Col>
                      <Col>
                        <IoIosArrowDropdownCircle
                          className="services-icon"
                          onClick={() => this.downService(services._id)}
                          size={60}
                          title="Descer serviço"
                        />
                        <IoIosArrowDropupCircle
                          className="services-icon"
                          onClick={() => this.upService(services._id)}
                          size={60}
                          title="Subir serviço"
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex align-items-center justify-content-between">
                      <Col lg={9} md={8} sm={12}>
                        <Form.Control
                          as="textarea"
                          className="edit-service-description-es mt-2"
                          rows={7}
                          defaultValue={services.description1.es}
                          style={{ resize: 'none' }}
                          placeholder="Adicione Descrição do Serviço em Espanhol"
                        />
                      </Col>
                      <Col>
                        <div
                          className="edit-card-pad"
                          style={{ marginTop: '1em' }}
                        >
                          <img
                            className={services._id}
                            src={`${process.env.REACT_APP_API_URI}/api/image/${services.image}`}
                            alt="imagem do serviço"
                            width="205px"
                            height="172px"
                          />
                          <div className="upload-image-div">
                            <label className="upload-image-text custom-file-upload">
                              <input
                                className="edit-service-image"
                                type="file"
                                onChange={(e) => {
                                  document.getElementsByClassName(services._id)[0].src = URL
                                    .createObjectURL(e.target.files[0]);
                                  document.getElementsByClassName(services._id)[1].src = URL
                                    .createObjectURL(e.target.files[0]);
                                }}
                              />
                              Alterar Imagem
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
                <div>
                  <small id={services._id} className="text-danger pre-wrap">
                    {' '}
                  </small>
                </div>
                <div className="d-flex justify-content-md-start justify-content-center">
                  <Button
                    onClick={(e) => this.editServices(e, services.key)}
                    variant="principal btn-custom"
                  >
                    Guardar alterações
                  </Button>
                  <Button
                    onClick={(e) => this.resetServices(e)}
                    variant="cancel btn-custom"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={() => this.handleShow(services._id, services.title1.pt)}
                    variant="red btn-custom"
                  >
                    Eliminar serviço
                  </Button>
                </div>
                <hr className="edit-divider divider-card" />
              </Form>
            ))}
          </div>
        </div>
        <DeleteModal
          id={idModal}
          show={showModal}
          handleClose={this.handleClose}
          handleDelete={this.handleDelete}
          title="Eliminar Serviço"
          body="Tem a certeza que pretende eliminar o serviço com o título "
          contentTitle={titleModal}
        />
        <SuccessMessage
          show={showToast}
          setShow={this.setShow}
          message={message}
        />
      </div>
    );
  }
}

ServicesEdit.propTypes = {
  Services: PropTypes.instanceOf(Object).isRequired,
};

export default ServicesEdit;
